import { defineMessages, useIntl } from 'react-intl';
import { Help, Rule, View } from '@carbon/icons-react';

import InfoCard from 'Components/Common/InfoCard/InfoCard';
import styles from './EventsConfigurationInfoCard.module.scss';

import cx from 'classnames';

const EventsConfigurationInfoCard = ({
    className,
}: {
    className?: string;
}) => {
    const intl = useIntl();

    return (
        <div className={cx(styles.wrapper, className)}>
            <InfoCard
                headingIcon={<Help size={20} />}
                title={intl.formatMessage(messages.title)}
                description={intl.formatMessage(messages.description)}
                items={[
                    {
                        icon: <Rule size={20} />,
                        title: intl.formatMessage(messages.alignWithYourParish),
                        description: intl.formatMessage(messages.alignWithYourParishDescription),
                    },
                    {
                        icon: <View size={20} />,
                        title: intl.formatMessage(messages.visibleForTeam),
                        description: intl.formatMessage(messages.visibleForTeamDescription),
                    },
                ]}
            />
        </div>
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.EventsConfiguration.EventsConfigurationInfoCard.title',
        defaultMessage: 'Dlaczego to ważne?',
    },
    description: {
        id: 'src.Screens.Dashboard.EventsConfiguration.EventsConfigurationInfoCard.description',
        defaultMessage: 'Rodzaje wydarzeń i posługi liturgiczne będą używane przy planowaniu wydarzeń oraz przypisywaniu osób.',
    },
    alignWithYourParish: {
        id: 'src.Screens.Dashboard.EventsConfiguration.EventsConfigurationInfoCard.alignWithYourParish',
        defaultMessage: 'Dostosuj do swojej parafii',
    },
    alignWithYourParishDescription: {
        id: 'src.Screens.Dashboard.EventsConfiguration.EventsConfigurationInfoCard.alignWithYourParishDescription',
        defaultMessage: 'Dodaj własne pozycje lub usuń te, których nie używasz, aby dopasować do potrzeb swojej parafii.',
    },
    visibleForTeam: {
        id: 'src.Screens.Dashboard.EventsConfiguration.EventsConfigurationInfoCard.visibleForTeam',
        defaultMessage: 'Widoczne dla zespołu',
    },
    visibleForTeamDescription: {
        id: 'src.Screens.Dashboard.EventsConfiguration.EventsConfigurationInfoCard.visibleForTeamDescription',
        defaultMessage: 'Ustawione tutaj opcje będą dostępne dla wszystkich użytkowników parafii.',
    },
});

export default EventsConfigurationInfoCard;
